<ng-template #loaderBlock>
  <app-loader></app-loader>  
</ng-template>
<div class="invoiceStatus">
  <div class="chart">
    <app-donut-chart
      *ngIf="initializeChart"
      [donutChartData]="invoiceStatus"
      [name]="'invoiceStatus'"
      [width]="chartWidth"
      [height]="chartHeight"
      [strokeWidth]="strokeWidth"
    ></app-donut-chart>
    <div class="content">
      <label>Total Revenue</label>
      <div><strong>${{totalRevenue}}M</strong></div>
    </div>
  </div>
  <div class="legend" *ngIf="invoice">
    <ul>
      <li>
        <h3>{{invoice.issued}}</h3>
        <label><span class="issued"></span>Issued</label>
      </li>
      <li>
        <h3>{{invoice.open}}</h3>
        <label><span class="open"></span>Open</label>
      </li>
      <li>
        <h3>{{invoice.pending}}</h3>
        <label><span class="pending"></span>Pending</label>
      </li>
      <li>
        <h3>{{invoice.paid}}</h3>
        <label><span class="paid"></span>Paid</label>
      </li>
    </ul>
  </div>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
